/**
 * @generated SignedSource<<f6bba9ed73551fae3f0472696f3db57d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PasswordStep_termsQuery$variables = {};
export type PasswordStep_termsQuery$data = {
  readonly termsAndConditions: {
    readonly formatted: any;
    readonly version: string;
  } | null;
};
export type PasswordStep_termsQuery = {
  response: PasswordStep_termsQuery$data;
  variables: PasswordStep_termsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TermsAndConditions",
    "kind": "LinkedField",
    "name": "termsAndConditions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "formatted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordStep_termsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PasswordStep_termsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "270b4281fc862baffc81f83a0dfa03db",
    "id": null,
    "metadata": {},
    "name": "PasswordStep_termsQuery",
    "operationKind": "query",
    "text": "query PasswordStep_termsQuery {\n  termsAndConditions {\n    version\n    formatted\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9feb7d601e0bf05c524bfa2f3b08479";

export default node;
